import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, isRef as _isRef, normalizeClass as _normalizeClass } from "vue"

import {computed, watch} from "vue";
import {SideMenuTabInteface} from "~/operatorApplication/vue/dialogs/dialog/sidemenu/Interface";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "SideMenuTabs"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    tabs: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["remove"], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;

let tabId = _useModel<string>(__props, "modelValue");

let selectedTab = computed(() => props.tabs.find(tab => tab.id == tabId.value));
watch(selectedTab, tab => {
    if (!tab && props.tabs?.length > 0) {
        tabId.value = props.tabs[0].id;
    }
}, {
    immediate: true
})

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createBlock(_component_el_tabs, {
    modelValue: _unref(tabId),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(tabId) ? (tabId).value = $event : tabId = $event)),
    class: _normalizeClass({'tabs': true, 'hide-header': _unref(props).tabs.length < 2}),
    type: "card",
    onTabRemove: _cache[1] || (_cache[1] = ($event: any) => (_unref(emits)('remove', $event)))
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (tab) => {
        return (_openBlock(), _createBlock(_component_el_tab_pane, {
          key: tab.id,
          name: tab.id,
          label: tab.descr,
          lazy: "",
          closable: tab.closable
        }, {
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(tab.descr) + " ", 1),
            (tab.badge)
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "danger",
                  size: "small",
                  class: "badge"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(tab.badge), 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            (tab.id == _unref(tabId) || !tab.unmountOnClose)
              ? _renderSlot(_ctx.$slots, tab.id, { key: 0 })
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["name", "label", "closable"]))
      }), 128))
    ]),
    _: 3
  }, 8, ["modelValue", "class"]))
}
}

})